<template>
    <div id="content">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"/>
        <div class="inner">
            <add-button v-if="$_createActionAllowed" :title="'Přidat konfiguraci zařízení' | translate" route-name="deviceConfigNew" />
            <h1 v-translate>Konfigurace zařízení</h1>
        </div>
      <div class="inner_white">
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
             :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>

        <div class="scroll-wrapper">
          <div class="table_overflow" id="contentBox" data-table-id="device-configs-list">
            <table class="vypis vypis_detail">
              <thead>
              <tr v-if="entities.length > 0">
                <th class="no_padding drag_drop"></th>
                <th class="no_padding checkbox"></th>
                <sorting-table-title
                    v-for="title in sortingTableTitles"
                    :key="title.key"
                    :column="title.column"
                    :sort="getActiveSort(title.column)"
                    @changeSorting="changeSorting"
                >{{ title.name }}
                </sorting-table-title>
                <th class="no_padding edit"></th>
              </tr>
              </thead>

              <device-config-row
                  v-for="entity in entities"
                  :entity="entity"
                  :key="entity.id"
                  @deleteDeviceConfig="deleteEntity"
                  :selectedEntities="selectedEntities"
                  @input="select"
                  :ref="'device-config-row-ref-'+entity.id"
              />
              <tr v-if="entities.length === 0">
                <td colspan="8" v-translate>Nebyly nalezeny žádné konfigurace zařízení.</td>
              </tr>
            </table>
          </div>
        </div>
        <list-action-line
            :entities="entities"
            :offset="formFields.offset"
            :limit="formFields.limit"
            :total-count="totalCount"
            @limit="setLimit"
            @offset="setOffset"
            table-id="device-configs-list"
            :selected-entities="selectedEntities"
            :multiple-action-options="multipleActionOptions"
            @select-all="toggleSelectAll"
            @run-multiple-action="runMultipleAction"
            ref="action_line"
        />
      </div>
    </div>
</template>

<script>
import DeviceConfigRow from "@/components/views/deviceConfigs/DeviceConfigRow"
import listActions from "@/components/mixins/list-actions"

export default {
    name: "DeviceConfigs",
    components: {
        DeviceConfigRow,
    },
    mixins: [listActions],
    data() {
        return {
            moduleName: 'deviceConfigs',
            formFields: {
                sort: {
                    column: 'sName',
                    direction: 'asc',
                }
            }
        }
    },
    created(DeviceConfigService) {
        this.entityService = DeviceConfigService
        this.createdInit()
    },
    computed: {
        deviceConfigsTableTitlesOperator() {
            return [
                {key: 1, name: this.$gettext('Název'), column: 'sName'},
                {key: 3, name: this.$gettext('Typy zařízení'), column: 'sNameDeviceType'},
                {key: 6, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
                {key: 7, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
            ]
        },
        deviceConfigsTableTitlesOwner() {
            return [
                {key: 1, name: this.$gettext('Název'), column: 'sName'},
                {key: 2, name: this.$gettext('Operátor'), column: 'sNameOperator'},
                {key: 3, name: this.$gettext('Typy zařízení'), column: 'sNameDeviceType'},
                {key: 6, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
                {key: 7, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
            ]
        },
        sortingTableTitles() {
            if (this.$_readActionAllowedAllOrOwnAndGlobal) {
                return this.deviceConfigsTableTitlesOwner
            } else {
                return this.deviceConfigsTableTitlesOperator
            }
        },
      multipleActionOptions() {
        return [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        ]
      },
      csvHeaders(){
        return this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
      },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/DeviceConfigsList.vue